import { useParams, useLocation, Link } from "react-router-dom";
import Nav from "../../components/layouts/nav";
import Footer from "../../components/layouts/footer";
import MetaSection from "../../components/MetaSection";
import Loader from "../../components/loader";
import ContentUnavailable from "../../components/ContentUnavailable";
import { useSelectedCountry, useCountryReady, useMenuList } from "../../_common/hooks/authHook";
import { URLS } from "../../_config";
import { replaceUrlParams } from "../../_common/functions";

const CategoryListing = () => {
    const { country, catSlug } = useParams<{ country: string; catSlug: string }>();
    const location = useLocation();
    const selectedCountry: any = useSelectedCountry();
    const countryReady: boolean = useCountryReady();
    const menuList: any[] = useMenuList() || [];

    if (!countryReady) {
        return <Loader />;
    }

    const category = menuList.find((m: any) => m?.slug === catSlug);

    if (!category) {
        return (
            <div className='bg-white'>
                {/* <MetaSection title="Category not found" desc="Category not found" url={location.pathname} noindex /> */}
                <Nav />
                <ContentUnavailable label="Category" />
                <Footer />
            </div>
        );
    }

    const countrySlug = country || selectedCountry?.country_name?.toLowerCase()?.replace(/\s+/g, '-');
    const pages = category?.pages || [];
    const childs = category?.childs || [];
    const isEmpty = pages.length === 0 && childs.every((child: any) => !(child?.childpages?.length > 0));

    return (
        <div className='bg-white'>
            {/* <MetaSection
                title={category?.cat_name || "Category"}
                desc={`Pages in ${category?.cat_name}`}
                url={location.pathname}
            /> */}
            <Nav />
            <div className="subscription">
                <div className="container">
                    <div className="banner-text latest_news_title">
                        <h2 data-aos="fade-up" className="text-left pb-1">{category?.cat_name}</h2>
                    </div>
                    {isEmpty ? (
                        <p className="text-center my-5">No pages available in this category yet.</p>
                    ) : (
                        <div className="row">
                            <div className="col-lg-8 col-md-12">
                                {pages.length > 0 && (
                                    <ul className="list-unstyled">
                                        {pages.filter((page: any) => page?.slug).map((page: any, idx: number) => (
                                            <li key={`cat-page-${idx}`} className="mb-2">
                                                <Link to={replaceUrlParams(URLS.MENU_PAGES.PAGE_DETAILS_DYNAMIC_CHILD, {
                                                    country: countrySlug, catSlug: category.slug, pageSlug: page.slug,
                                                })}>
                                                    {page.title || page.slug}
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                )}
                                {childs.map((child: any, childIdx: number) => (
                                    child?.childpages?.length > 0 && (
                                        <div key={`cat-child-${childIdx}`} className="mb-4">
                                            <h4>{child?.cat_name}</h4>
                                            <ul className="list-unstyled">
                                                {child.childpages
                                                    .filter((subChild: any) => subChild?.is_active === 1 && subChild?.slug)
                                                    .map((subChild: any, subIdx: number) => (
                                                        <li key={`cat-child-page-${childIdx}-${subIdx}`} className="mb-2">
                                                            <Link to={replaceUrlParams(URLS.MENU_PAGES.PAGE_DETAILS_DYNAMIC_PAGE, {
                                                                country: countrySlug, catSlug: category.slug,
                                                                childCatSlug: child.slug, pageSlug: subChild.slug,
                                                            })}>
                                                                {subChild.title || subChild.slug}
                                                            </Link>
                                                        </li>
                                                    ))}
                                            </ul>
                                        </div>
                                    )
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default CategoryListing;
